export const addFilterBikeParameter = (bikeId: string): void => {
    const currentUrl = new URL(window.location.href, window.location.origin);
    currentUrl.searchParams.set('filter_bike_id', bikeId);
    history.replaceState({ path: currentUrl.toString() }, document.title, currentUrl.toString())
}

export const addProductConcreteFilterParameter = (sku: string): void => {
    const url = new URL(window.location.href, window.location.origin);
    const parameter = 'filter_article_number';

    if (url.searchParams.get(parameter)) {
        url.searchParams.delete(parameter);
    }
    url.searchParams.append(parameter, sku);
    history.replaceState({ path: url.toString() }, document.title, url.toString());
}

export const updateRecommendationApiUrl = (recommendationApiUrl: string, sku: string): string => {
    //TODO: an empty sku is not normal case, it should be investigated!
    if (!sku) {
        return recommendationApiUrl;
    }

    const addToCardIdParam = sku;
    const skuList = addToCardIdParam.split('~');
    const productIdParam = skuList.length > 1 ? skuList[1] : skuList[0];

    const newRecommendationApiUrl =  new URL(recommendationApiUrl, window.location.origin);
    newRecommendationApiUrl.searchParams.set('addToCartId', addToCardIdParam);
    newRecommendationApiUrl.searchParams.set('productId', productIdParam);

    return newRecommendationApiUrl.toString();
}
